export class CheckoutInfo {
  firstName = "";
  lastName = "";
  phone = "";
  dob = "";
  email = "";
  textAlerts = false;
  emailAlerts = false;
}
